import { useAnalyticContext } from '@application/analytic/analytic_context.provider';
import { Skeleton } from '@view/view_create_new_message/components/skeleton';
import { ScreenError } from '@view/view_create_new_message/screens/error';
import { useEffect, useRef, useState } from 'react';
import { useCreateNewMessage } from '../../hooks/use-create-new-message';

export const ScreenSetup = () => {
	const { isClosed, setupNewBasket, goToScreen } = useCreateNewMessage();
	const [error, setError] = useState(false);
	const analytic = useAnalyticContext();
	const hasRun = useRef(false);

	useEffect(() => {
		if (isClosed) return;
		if (hasRun.current) return;
		hasRun.current = true;

		setupNewBasket()
			.then(() => goToScreen('start'))
			.catch(() => setError(true));

		analytic.trackEvent('Setup new basket');
	}, [isClosed, setupNewBasket, goToScreen, analytic]);

	if (error) {
		return <ScreenError />;
	}

	return <Skeleton />;
};
